export default "__VITE_ASSET__COUjEc8P__"